<template>
  <tr>
    <th scope="row">
      <label :for="'check_' + modelValue.cuota">
        <input
          type="checkbox"
          :name="'check_' + modelValue.cuota"
          :id="'check_' + modelValue.cuota"
          v-model="modelValue.seleccionada"
          @change="changeCheckbox"
        />
        <span>{{ modelValue.cuota }}</span>
      </label>
    </th>
    <td>
      {{ moneyFormat(modelValue.valor, 2) }}
    </td>
    <td>
      {{ moneyFormat(modelValue.total_pagado, 2) }}
    </td>
    <td width="20%">
      <!-- :disabled="!modelValue.seleccionada" -->
      <input-field
        v-if="modelValue.seleccionada"
        vMoney
        :format="money"
        v-model="modelValue.valor_pago"
        :id="'valor_a_pagar_' + modelValue.cuota"
        :name="'valor_a_pagar_' + modelValue.cuota"
        placeholder="Valor"
      ></input-field>
    </td>
    <td>
      {{ saldo }}
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      modelValue: this.value,
      moneyFormat: moneyFormat,
      money: money,
    };
  },
  methods: {
    changeCheckbox: function () {
      if (this.modelValue.seleccionada) {
        this.modelValue.valor_pago = this.modelValue.saldo;
      } else {
        this.modelValue.valor_pago = 0;
      }
      this.$emit('selectCuotasInferiores');
    }
  },
  computed: {
    saldo: function () {
      let valor = parseFloat(this.modelValue.valor);
      if (isNaN(valor)) valor = 0;
      let total_pagado = parseFloat(this.modelValue.total_pagado);
      if (isNaN(total_pagado)) total_pagado = 0;
      let valor_pago = parseFloat(this.modelValue.valor_pago);
      if (isNaN(valor_pago)) valor_pago = 0;
			let saldo = parseFloat(round(valor - total_pagado, 2));
      if (isNaN(saldo)) saldo = 0;
      if (valor_pago > valor || valor_pago > saldo) {
        this.modelValue.valor_pago = 0;
        return moneyFormat(this.modelValue.saldo, 2);
      }
			this.modelValue.saldo = round(saldo - valor_pago, 2);
			return moneyFormat(this.modelValue.saldo, 2);
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/prestamos/cobros/TrCuota.vue